import { clamp } from '@antv/util';
export function numberToString(x) {
  return x.toFixed(3).replace(/0+$/, '').replace(/\.$/, '');
}
export function parseNumber(string) {
  if (typeof string === 'number') {
    return string;
  }

  if (/^\s*[-+]?(\d*\.)?\d+\s*$/.test(string)) {
    return Number(string);
  } else {
    return 0;
  }
}
export function mergeNumbers(left, right) {
  return [left, right, numberToString];
}
export function clampedMergeNumbers(min, max) {
  return function (left, right) {
    return [left, right, function (x) {
      return numberToString(clamp(x, min, max));
    }];
  };
}
export function mergeNumberLists(left, right) {
  if (left.length != right.length) {
    return;
  }

  return [left, right, function (numberList) {
    return numberList;
  }];
}